export const THEME_COLOR = "#E13F57";

export const labelStyle = {
  fontWeight: "500",
  color: "#374151",
  fontSize: "14px",
  marginBottom: "6px",
  display: "block",
};

export const inputStyle = {
  border: "1px solid #d1d5db",
  borderRadius: "8px",
  padding: "10px 14px",
  fontSize: "14px",
  transition: "all 0.2s ease",
};

export const textareaStyle = {
  ...inputStyle,
  minHeight: "110px",
  resize: "vertical",
};

export const selectStyle = {
  ...inputStyle,
  paddingRight: "32px",
};

export const sectionHeaderStyle = {
  display: "flex",
  alignItems: "center",
  gap: "12px",
  marginBottom: "16px",
};

export const sectionIconStyle = {
  color: THEME_COLOR,
  fontSize: "18px",
};

export const sectionTitleStyle = {
  margin: 0,
  fontWeight: "600",
  color: "#111827",
  fontSize: "16px",
};
